/**
 * `buyerCheckout.*` — buyer checkout + order placement (spec 37).
 */
import { z } from "zod";
import { uuid, moneyPaise, phoneIN } from "../_common.js";

const orderLine = z.object({
  listingSlug: z.string(),
  entryId: z.string(),
  packName: z.string(),
  packQty: z.number().int().min(1).max(9999),
  pricePaise: moneyPaise,
  pieces: z.number().int(),
});

export const placeOrderInput = z.object({
  storeSlug: z.string().min(1).max(64),
  delivery: z.object({
    contactName: z.string().trim().min(1).max(160),
    phone: phoneIN,
    address: z.string().trim().min(1).max(500),
    city: z.string().trim().min(1).max(100),
    state: z.string().trim().min(1).max(100),
    pin: z.string().regex(/^[1-9][0-9]{5}$/, "6-digit PIN"),
  }),
  gstin: z
    .string()
    .regex(/^[0-9]{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/)
    .optional(),
  lines: z.array(orderLine).min(1).max(50),
});

export const placeOrderOutput = z.object({
  orderId: uuid,
  ref: z.string(),
  totalPaise: moneyPaise,
});
